// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ItemDetailClient = registerClientReference(
    function() { throw new Error("Attempted to call ItemDetailClient() from the server but ItemDetailClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(buyer)/items/[id]/item-detail-client.tsx",
    "ItemDetailClient",
);
